import { Dispatcher } from '@sqior/js/operation';
import React from 'react';

export const OperationContext = React.createContext(new Dispatcher());
